import React from 'react'
import {RadialGauge} from 'canvas-gauges'


class ReactRadialGauge extends React.Component {
  
  componentDidMount () {
    if (this.props.range) {
      let range = this.props.range.to - this.props.range.from
      var MajorTicks = []
      for (let i =0; i <= 10; i++) {
          MajorTicks.push(parseInt(this.props.range.from) + (range*i/10))
      }
    } else {
      var MajorTicks = []
      for (let i =0; i <= 10; i++) {
          MajorTicks.push(0 + (100*i/10))
      }
    }
    
    const options = Object.assign({}, this.props, {
    renderTo: this.el,
    width: this.props.size ? this.props.size : (window.innerWidth)*0.16666667,
    height: this.props.size ? this.props.size : (window.innerWidth)*0.16666667,
    units: this.props.data ? this.props.data.units : "KW",
    minValue: this.props.range ? this.props.range.from : 0,
    maxValue: this.props.range ? this.props.range.to : 120,
    majorTicks: MajorTicks,
    highlights: [
        
    ],
    minorTicks: 10,
    strokeTicks: false,
    colorPlate: "rgba(255,255,255, 0)",
    borderShadowWidth: 2,
    value: this.props.value ? this.props.value : 0,
    borders: false,
    needleType: "arrow",
    needleWidth: 2,
    colorNeedle: "#FF9D27",
    needleShadow: false,
    startAngle: 90,
    ticksAngle: 230,
    borderOuterWidth:10,
    colorNeedleCircleOuter: '#FF9D27',
    colorNeedleCircleOuterEnd: '#FF9D27',
    colorNeedleCircleInner: '#FF9D27',
    colorNeedleCircleInnerEnd: '#FF9D27',
    valueDec : 3,
    needleCircleSize: 7,
    // colorValueBoxRect:'black',
    colorNeedleShadowUp : '',
    highlightsLineCap:'square',
    needleCircleOuter: true,
    needleCircleInner: true,
    animation: false,
    animationDuration: 15,
    animationRule: "linear"
    })
    this.gauge = new RadialGauge(options).draw()
  }
  
  componentWillReceiveProps (nextProps) {
    this.gauge.value = nextProps.value
    // console.log(nextProps.value)
    this.gauge.update(nextProps)
  }

  render () {
    return (
            <canvas data-paper-resize ref={(canvas) => {
                this.el = canvas
            }} />
    )
  }
}

export default ReactRadialGauge